import careers from '../modules/careers/locales/en.json';
import jobs from '../modules/jobs/locales/en.json';
import job_form from '../modules/job-form/locales/en.json';
import jobDetail from '../modules/job-detail/locales/en.json';
import jobBoards from '../modules/job-boards/locales/en.json';
import settings from '../modules/settings/locales/en.json';
import application from '../modules/application/locales/en.json';
import candidates from '../modules/candidates/locales/en.json';
import interviews from '../modules/interviews/locales/en.json';
import staticPages from '../modules/static/locales/en.json';
import common from './common.json';

const combined = {
  common,
  ...careers,
  ...jobs,
  ...job_form,
  ...jobDetail,
  ...jobBoards,
  ...settings,
  ...application,
  ...candidates,
  ...interviews,
  ...staticPages,
};

export default combined;
